import { observer } from "mobx-react-lite";
import { useState } from "react";
import { View, XStack, YStack } from "tamagui";
import { useStores } from "../core/stores";
import { Body } from "./Body";
import { Button } from "./Button";
import { FeedbackModal } from "./navigation/FeedbackModal";
import { Separator } from "./Separator";

export const Footer = observer(() => {
  const { sessionStore } = useStores();

  const [showFeedbackSheet, setFeedbackSheet] = useState("");

  if (!sessionStore.isLoggedIn) {
    return null;
  }

  return (
    <YStack marginVertical={"$large"}>
      <Separator noMargins />
      <XStack
        gap="$small"
        zIndex={0}
        flex={1}
        marginHorizontal="$medium"
        alignItems="center"
        padding="$medium"
        justifyContent="center"
      >
        <Button
          type="ghost"
          onPress={() => {
            setFeedbackSheet("Contact us");
          }}
        >
          <Body muted>Contact us</Body>
        </Button>
        <View backgroundColor={"$divider"} width={2} height={20} />
        <Button
          type="ghost"
          onPress={() => {
            setFeedbackSheet("Support");
          }}
        >
          <Body muted>Support</Body>
        </Button>
        <View backgroundColor={"$divider"} width={2} height={20} />
        <Button
          type="ghost"
          onPress={() => {
            setFeedbackSheet("Feedback");
          }}
        >
          <Body muted>Feedback</Body>
        </Button>
      </XStack>

      <Body muted numberOfLines={1} alignSelf="center">
        Planira © {new Date().getFullYear()}
      </Body>

      <FeedbackModal
        title={showFeedbackSheet}
        userUid={sessionStore.uid}
        visible={!!showFeedbackSheet}
        onClose={() => setFeedbackSheet("")}
      />
    </YStack>
  );
});
